export default __webpack_public_path__ + "static/media/kinoplex.4520c332.jpg";